import { FieldsStructure, FieldStructure, FormDataStructure } from '@/contracts/forms/FieldContracts'

export function getStage1FormDataStructure(formData?: FormDataStructure): FieldsStructure
{
    const fields =
    {
        lastname:
        {
            name: 'lastname',
            type: 'Input',
            label: 'Last name',
            inputType: 'text',
            autocomplete: 'family-name',
            fieldset: 'lastname',
            width: 'govuk-input--width-20',
            rules:
            {
                required:
                {
                    config: true
                },
                max:
                {
                    config: 255
                }
            }
        },
        firstname:
        {
            name: 'firstname',
            type: 'Input',
            label: 'First name (Optional)',
            inputType: 'text',
            autocomplete: 'given-name',
            fieldset: 'firstname',
            width: 'govuk-input--width-20',
            rules:
            {
                max:
                {
                    config: 255
                }
            }
        },
        yearofdeath:
        {
            name: 'yearofdeath',
            type: 'Input',
            label: 'Year of death',
            hint: 'For example 1996',
            inputType: 'number',
            fieldset: 'yearofdeath',
            width: 'govuk-input--width-4',
            rules:
            {
                required:
                {
                    config: true
                },
                year:
                {
                    config: true
                }
            }
        },
        wasasoldier:
        {
            name: 'wasasoldier',
            type: 'Radio',
            label: 'Was the person a soldier',
            fieldset: 'wasasoldier',
            value: 0,
            options:
            [
                {
                    name: 'yes',
                    label: 'Yes',
                    value: 1
                },
                {
                    name: 'no',
                    label: 'No',
                    value: 0,
                    default: true
                }
            ],
            rules:
            {
                required:
                {
                    config: true,
                    message: 'Please select if the person was a soldier'
                }
            }
        }
    }
    // Return fields if no form data exists:
    if(formData === undefined)
    {
        return fields
    }
    // Return with form data:
    return fillWithFormData(fields, formData)
}

export function getStage2FormDataStructure(grantType: number, formData?: FormDataStructure): FieldsStructure
{
    // Set all available fields:
    let fields =
    {
        keywords:
        {
            name: 'keywords',
            type: 'Input',
            label: 'Keyword(s) (Optional)',
            hint: 'Please enter a space between keywords for example Farnham Surrey. Do not enter commas. When names contain hyphens please include them, for example Stoke-on-Trent',
            inputType: 'text',
            fieldset: 'keywords',
            width: 'govuk-input--width-10',
            inset: 'These are used to target the image search results more accurately. These could include a street name, village, town or city, relative\'s name or any keyword relating to the probate.',
            rules:
            {

            }
        },
        monthofdeath:
        {
            name: 'monthofdeath',
            type: 'Input',
            label: 'Month of death (Optional)',
            hint: 'For example, the month of March should be entered as 03',
            inputType: 'text',
            fieldset: 'monthofdeath',
            width: 'govuk-input--width-2',
            rules:
            {
                month:
                {
                    config: true
                }
            }
        },
        dayofdeath:
        {
            name: 'dayofdeath',
            type: 'Input',
            label: 'Day of death (Optional)',
            hint: 'For example, 25',
            inputType: 'text',
            fieldset: 'dayofdeath',
            width: 'govuk-input--width-2',
            rules:
            {
                day:
                {
                    config: true
                },
                requires:
                {
                    config: 'monthofdeath'
                }
            }
        },
        yearofprobate:
        {
            name: 'yearofprobate',
            type: 'Input',
            label: 'Year of probate (Optional)',
            hint: 'For example, 1996',
            inputType: 'number',
            fieldset: 'yearofprobate',
            width: 'govuk-input--width-4',
            rules:
            {
                year:
                {
                    config: true
                }
            }
        },
        monthofprobate:
        {
            name: 'monthofprobate',
            type: 'Input',
            label: 'Month of probate (Optional)',
            hint: 'For example, the month of March should be entered as 03',
            inputType: 'text',
            fieldset: 'monthofprobate',
            width: 'govuk-input--width-2',
            rules:
            {
                month:
                {
                    config: true
                },
                requires:
                {
                    config: 'yearofprobate'
                }
            }
        },
        dayofprobate:
        {
            name: 'dayofprobate',
            type: 'Input',
            label: 'Day of probate (Optional)',
            hint: 'For example, 25',
            inputType: 'text',
            fieldset: 'dayofprobate',
            width: 'govuk-input--width-2',
            rules:
            {
                day:
                {
                    config: true
                },
                requires:
                {
                    config: 'monthofprobate'
                }
            }
        },
        regimentalnumber:
        {
            name: 'regimentalnumber',
            type: 'Input',
            label: 'Regimental number (Optional)',
            hint: 'For example 14279',
            inputType: 'number',
            fieldset: 'regimentalnumber',
            width: 'govuk-input--width-10',
            rules:
            {
                number:
                {
                    config: true
                }
            }
        }
    } as FieldsStructure
    // Hold allowed fields:
    let allowed = [] as string[]
    // Remove fields based on grant type:
    switch(grantType)
    {
        case 1:
            allowed = ['keywords', 'monthofdeath', 'dayofdeath', 'yearofprobate', 'monthofprobate', 'dayofprobate']
            fields = Object.fromEntries(
                Object.entries(fields).filter(([key]) => allowed.includes(key))
            ) as FieldsStructure
            break
        case 2:
            allowed = ['keywords', 'monthofdeath', 'dayofdeath', 'yearofprobate', 'monthofprobate', 'dayofprobate']
            fields = Object.fromEntries(
                Object.entries(fields).filter(([key]) => allowed.includes(key))
            ) as FieldsStructure
            break
        case 3:
            allowed = ['monthofdeath', 'dayofdeath', 'regimentalnumber']
            fields = Object.fromEntries(
                Object.entries(fields).filter(([key]) => allowed.includes(key))
            ) as FieldsStructure
            break
    }
    // Return fields if no form data exists:
    if(formData === undefined)
    {
        return fields
    }
    // Return with form data:
    return fillWithFormData(fields, formData)
}

export function getAdditionalFormDataStructure(yearOfDeath: number): FieldsStructure
{
    const fields =
    {
        lastname:
        {
            name: 'lastname',
            type: 'Input',
            label: 'Last name',
            inputType: 'text',
            autocomplete: 'family-name',
            fieldset: 'lastname',
            width: 'govuk-input--width-20',
            rules:
            {
                required:
                {
                    config: true
                },
                max:
                {
                    config: 255
                }
            }
        },
        firstname:
        {
            name: 'firstname',
            type: 'Input',
            label: 'First name(s)',
            hint: 'Include any middle names if applicable',
            inputType: 'text',
            autocomplete: 'given-name',
            fieldset: 'firstname',
            width: 'govuk-input--width-20',
            rules:
            {
                required:
                {
                    config: true
                },
                max:
                {
                    config: 255
                }
            },
            inset: 'Please note, failure to enter the deceased’s name in full will result in a ‘no find’ notification being issued instead of your desired Probate documents and you will not be eligible for a refund.'
        },
        dateofprobate:
        {
            name: 'dateofprobate',
            type: 'Date',
            label: 'What was their date of probate?',
            hint: 'For example, 25 03 2007',
            fieldset: 'dateofprobate',
            rules:
            {
                required:
                {
                    config: true
                },
                date:
                {
                    config: true
                },
                max:
                {
                    config: '31/12/1996',
                    message: 'Year cannot be greater than 1996'
                }
            }
        },
        dateofdeath:
        {
            name: 'dateofdeath',
            type: 'Date',
            label: 'What was their date of death?',
            hint: 'For example, 25 03 2007',
            fieldset: 'dateofdeath',
            rules:
            {
                required:
                {
                    config: true
                },
                date:
                {
                    config: true
                }
            }
        },
        registrylocation:
        {
            name: 'registrylocation',
            type: 'Select',
            label: 'Registry location',
            fieldset: 'registrylocation',
            value: '',
            selectoptions:
            [
                'London',
                'Birmingham',
                'Brighton',
                'Bristol',
                'Ipswich',
                'Leeds',
                'Liverpool',
                'Cardiff',
                'Manchester',
                'Newcastle Upon Tyne',
                'Oxford',
                'Winchester',
                'Caernarfon',
                'Bodmin',
                'Carlisle',
                'Carmarthen',
                'Chester',
                'Exeter',
                'Gloucester',
                'Lancaster',
                'Leicester',
                'Lincoln',
                'Maidstone',
                'Middlesbrough',
                'Norwich',
                'Nottingham',
                'Peterborough',
                'Sheffield',
                'Stoke-on-Trent',
                'York',
                'Bangor',
                'Blandford',
                'Bury St Edmonds',
                'Canterbury',
                'Chichester',
                'Coventry',
                'Derby',
                'Durham',
                'Hereford',
                'Hull',
                'Lewes',
                'Lichfield',
                'Llandaff',
                'Newcastle',
                'Northampton',
                'Principal Registry',
                'Probate Registry of Wales',
                'Salisbury',
                'Shrewsbury',
                'St Asaph',
                'Taunton',
                'Wakefield',
                'Wells',
                'Worcester',
                'Llandudno',
                'Unknown Registry Office'
            ],
            rules:
            {
                required:
                {
                    config: true
                }
            }
        }
    } as FieldsStructure

    fields.folionumber =
    {
        name: 'folionumber',
        type: 'Input',
        label: 'Folio number',
        inputType: 'number',
        fieldset: 'folionumber',
        width: 'govuk-input--width-10',
        details:
        {
            label: 'Help with folio number',
            detail: 'A Folio Number must be entered into the ‘Folio Number’ text box wherever available (excluding any letters). However, some results may not have an associated Folio Number. If there is no number present then this field can be left blank. Please note that Folio Number positions and format do vary. You may find the Folio Number is hand written next to the relevant entry.',
            open: true
        },
        show: function(inputs: FieldsStructure)
        {
            let passedDateCheck = false
            if(inputs.dateofprobate.value !== undefined)
            {
                const cDate = new Date(inputs.dateofprobate.value.split('/')[2])
                if(cDate.getUTCFullYear() !== undefined && cDate.getUTCFullYear() > 1000 && cDate.getUTCFullYear() < 1931)
                {
                    passedDateCheck = true
                }
            }
            return passedDateCheck && (inputs.registrylocation.value === 'London' || inputs.registrylocation.value === 'Principal Registry')
        },
        rules:
        {
            required:
            {
                config: false
            },
            max:
            {
                config: 255
            },
            number:
            {
                config: true
            }
        }
    }
    return fields
}

function fillWithFormData(fields: FieldsStructure, formData: FormDataStructure): FieldsStructure
{
    // Loop fields in form:
    for(const [name] of Object.entries(fields))
    {
        if(formData[name] !== undefined)
        {
            fields[name].value = formData[name]
        }
    }
    return fields
}
